var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8789 17.9066C27.8789 18.758 27.1887 19.4482 26.3372 19.4482H7.54557C6.69413 19.4482 6.00391 18.758 6.00391 17.9066C6.00391 17.0551 6.69413 16.3649 7.54557 16.3649H26.3372C27.1887 16.3649 27.8789 17.0551 27.8789 17.9066ZM27.8789 10.1982C27.8789 11.0497 27.1887 11.7399 26.3372 11.7399H10.5456C9.69413 11.7399 9.00391 11.0497 9.00391 10.1982C9.00391 9.3468 9.69413 8.65658 10.5456 8.65658H26.3372C27.1887 8.65658 27.8789 9.3468 27.8789 10.1982ZM26.3372 0.948242C27.1887 0.948242 27.8789 1.63847 27.8789 2.48991C27.8789 3.34135 27.1887 4.03158 26.3372 4.03158H1.67057C0.819134 4.03158 0.128906 3.34135 0.128906 2.48991C0.128906 1.63847 0.819134 0.948242 1.67057 0.948242H26.3372Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.62c88f9b62e879d7dd4d66f48cfcb824.svg";
export { ForwardRef as ReactComponent };